// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EntityCategoryLabel__entityCategoryLabel___X2RHI{display:flex;align-items:center;font-weight:400;color:#666;font-size:14px}\n", ""]);
// Exports
exports.locals = {
	"entityCategoryLabel": "EntityCategoryLabel__entityCategoryLabel___X2RHI"
};
module.exports = exports;
